import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Button, Modal } from "reactstrap";
import { Initialized_Payout_Reset } from "../../../../redux/slices/payoutSlice";
import CustomeButton from "../../Forms/CustomeButton/CustomeButton";
import { responseToaster } from "../../../../helperFunctions";

const SetInitializedModal = (props) => {
  const { isOpen, onHide, onGet } = props;
  const dispatch = useDispatch();

  const [isButtonLoading, setIsButtonLoading] = useState(false);

  const Payout_Reset = async () => {
    try {
      setIsButtonLoading(true);
      const payload = {
        withdrawalId: isOpen,
      };
      const response = await dispatch(
        Initialized_Payout_Reset(payload)
      ).unwrap();
      responseToaster(response);
      if (!!response) {
        onHide();
        onGet();
      }
      setIsButtonLoading(false);
    } catch (err) {
      setIsButtonLoading(false);
    }
  };
  return (
    <Modal isOpen={!!isOpen} toggle={() => onHide()} centered={true}>
      <div className="modal-header">
        <h3 className="modal-title mt-0">Initialized Withdraw</h3>
        <i
          onClick={() => {
            onHide();
          }}
          className="fa-solid fa-xmark"
        ></i>
      </div>
      <div className="modal-body">
        <div>
          <p>Are you sure you want to initialized this withdraw?</p>
        </div>
      </div>
      <div className="modal-footer">
        <div className="d-flex justify-content-end button-space">
          <Button className="graybutton" onClick={() => onHide()}>
            Cancel
          </Button>
          <CustomeButton
            className="submitbutton"
            onClick={Payout_Reset}
            isButtonLoading={isButtonLoading}
          >
            Submit
          </CustomeButton>
        </div>
      </div>
    </Modal>
  );
};

export default SetInitializedModal;
